
import Vue from "vue";
import assistIconSrc from "@/assets/icons/assist-icon.svg";

export interface AssistFabProps {
  disabled?: boolean;
}

export default Vue.extend({
  name: "AssistFab",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      assistIconSrc,
    };
  },
  methods: {
    handleClick(): void {
      if (!this.disabled) {
        this.$emit("click");
      }
    },
  },
});
